module.exports = __webpack_public_path__ + "img/logo_mmi.ce3e784b.png";